'use client'
import { BreadcrumbSeparator as ChakraBreadcrumbSeparator } from '@chakra-ui/react'
import { forwardRef, LegacyRef } from 'react'

import { BreadcrumbSeparatorProps } from './BreadcrumbSeparator.types'

export default forwardRef(function BreadcrumbSeparator(
  props: BreadcrumbSeparatorProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraBreadcrumbSeparator {...props} ref={ref} translate="no" />
})
